import MLink from "./MLink.vue";
export default MLink;
